<template>
  <div>
    <v-layout row wrap class="pl-4 pt-2">
      <v-flex  xs2>
        <span class="d-block font-weight-bold">Quantidade</span>
        <span>{{ acompanhamentoDetalhes.quantidade }}</span>
      </v-flex>
      <v-flex  xs2>
        <span class="d-block font-weight-bold">Valor Unitário Estimado</span>
        <span v-if="acompanhamentoDetalhes.mostrarValorReserva">
          R$ {{ valorFormatado(this.acompanhamentoDetalhes.valorUnitarioEstimado, this.acompanhamentoDetalhes.casasDecimais) }}</span>
        <span v-else>Sigiloso</span>
      </v-flex>
      <v-flex  xs2>
        <span class="d-block font-weight-bold">Valor Total Estimado</span>
        <span v-if="acompanhamentoDetalhes.mostrarValorReserva">
          R$ {{ valorFormatado(this.acompanhamentoDetalhes.valorTotalEstimado, this.acompanhamentoDetalhes.casasDecimais) }}</span>
        <span v-else>Sigiloso</span>
      </v-flex>
      <v-flex  xs2 v-if="situacao === 'ENCERRADA'">
        <span class="d-block font-weight-bold">Valor Total Final</span>
        <span>R$ {{ valorFormatado(this.acompanhamentoDetalhes.valorTotalFinal, this.acompanhamentoDetalhes.casasDecimais) }}</span>
      </v-flex>
    </v-layout>
    <div style="width: 100%" class="px-4 pt-2">
      <hr class="mx-0" />
    </div>
    <v-data-table v-if="acompanhamentoDetalhes.chatLicitacao"
                  :headers="colunas" :items="acompanhamentoDetalhes.chatLicitacao"
                  :total-items="acompanhamentoDetalhes.chatLicitacao.length"
                  :loading="false" hide-actions
                  no-data-text="Não há acompanhamentos disponíveis"
                  class="az-table-list px-4 pt-2">
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            {{props.item.dataHora | az-date('DD/MM/YYYY HH:mm:ss.SSS')}}
          </td>
          <td>
            {{ props.item.usuario || '-'}}
          </td>
          <td>
            {{ props.item.mensagem || '-'}}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>

export default {
    name: 'AcompanhamentoTabela',
    props:{
        acompanhamentoDetalhes:{
            type: Array,
            default: () => []
        },
        situacao:{
            type: String,
        }
    },
    data(){
        return{
            colunas: [
                {
                    value: 'dataHora',
                    text: 'Data/Hora',
                    align: 'left',
                    width: '12%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'usuario',
                    text: 'Usuário',
                    align: 'left',
                    width: '16%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'mensagem',
                    text: 'Mensagem',
                    align: 'left',
                    width: '50%',
                    sortable: false,
                    class: 'primary--text'
                },
            ],
        }
    },
    methods: {
        valorFormatado(valor, casasDecimais) {
            if(valor) {
                const numArr = valor.toFixed(casasDecimais).split('.')
                return numArr[0].split('').reverse().reduce(function (acc, num, i) {
                    const separator = i && !(i % 3) ? '.' : ''
                    return num === '-' ? acc : num + separator + acc
                }, '') + ',' + numArr[1]
            }
        }
    }
}

</script>